var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-component',{attrs:{"headers":_vm.headers,"data":_vm.traceabilityConfig,"loading":_vm.loading,"colors":_vm.colors,"rowActions":_vm.tableActions,"pagination":_vm.pagination},on:{"changePagination":_vm.onChangePage}})}
var staticRenderFns = []

export { render, staticRenderFns }